module.exports = {"540102002":"八廓街道","540102003":"吉日街道","540102004":"吉崩岗街道","540102005":"扎细街道","540102006":"公德林街道","540102007":"嘎玛贡桑街道","540102008":"两岛街道","540102009":"金珠西路街道","540102200":"蔡公堂乡","540102201":"纳金乡","540102202":"娘热乡","540102203":"夺底乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540102.json
// module id = 2673
// module chunks = 0